<template>
  <div class="row border-bottom border-3 mb-2">
    <div class="col">
      <div>Total:</div>
      <h4 class="text-primary fw-bold">{{ commas(Total) }}</h4>
    </div>
    <div class="col">
      <div>Given Away:</div>
      <h4 class="text-primary fw-bold">{{ commas(GiveAway) }}</h4>
    </div>
    <div class="col">
      <div>Balance:</div>
      <h4 v-if="fetched" class="text-primary fw-bold">{{ commas(Total - GiveAway) }}</h4>
      <h4 v-else class="text-primary fw-bold">{{ 0 }}</h4>
    </div>
  </div>
</template>

<script>
import { contributionMethods, contributionComputed, giveAwayMethods, giveAwayComputed } from "@/state/helpers";

export default {
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      fetched: false,
    }
  },
  methods: {
    ...contributionMethods,
    ...giveAwayMethods,
    commas(x) { return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); },
  },
  async mounted() {
    await this.fetchContributions();
    this.fetched = true;
    this.fetchGiveAways();
  },
  computed: {
    ...contributionComputed,
    ...giveAwayComputed,
    Total() {
      if (this.fetched) {
        return this.contributions
          .filter(d => d.status == 2)
          .reduce((a, b) => a + Number(b.amount), 0);
      } else {
        return 0;
      }
    },

    GiveAway() {
      if (this.fetched) {
        return this.giveaways
          .filter(d => d.status == 2)
          .reduce((a, b) => a + Number(b.amount), 0);
      } else {
        return 0;
      }
    },
  },
}
</script>